import { AUTH_PROCESSING, CREATE_USER, REQUEST_TOKEN } from './actionType';

export const requestToken = () => {
    return {
        type: REQUEST_TOKEN
    };
};

export const createUser = data => {
    return {
        type: CREATE_USER,
        payload: data
    };
};

// TODO: Delete after final refactoring ->
// LOADING FOR MOST BUTTONS
export const authProcess = data => {
    return {
        type: AUTH_PROCESSING,
        payload: data
    };
};
